import React from 'react';

const Check = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <mask
        id="mask0_5947_114674"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="32"
      >
        <rect width="32" height="32" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5947_114674)">
        <path
          d="M12.7333 20.2L24.0333 8.9C24.2999 8.63333 24.6166 8.5 24.9833 8.5C25.35 8.5 25.6666 8.63333 25.9333 8.9C26.1999 9.16667 26.3333 9.48333 26.3333 9.85C26.3333 10.2167 26.1999 10.5333 25.9333 10.8L13.6666 23.0667C13.4 23.3333 13.0888 23.4667 12.7333 23.4667C12.3777 23.4667 12.0666 23.3333 11.8 23.0667L6.06662 17.3333C5.79995 17.0667 5.67217 16.75 5.68328 16.3833C5.69439 16.0167 5.83328 15.7 6.09995 15.4333C6.36662 15.1667 6.68328 15.0333 7.04995 15.0333C7.41662 15.0333 7.73328 15.1667 7.99995 15.4333L12.7333 20.2Z"
          fill="#FF8D00"
        />
      </g>
    </svg>
  );
};

export default Check;
